module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": _vm.subNavTitle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [(this.capsule === 'draft-edit') ? _c('f7-list', {
    staticClass: "draftTitle"
  }, [_c('f7-list-item', [_c('f7-label', {
    staticClass: "paymentsRequestSubOption formLabel formLabelPayment"
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("Draft name")]), _vm._v(" "), _c('f7-input', {
    staticClass: "paymentsRequestSubOption",
    attrs: {
      "placeholder": "Draft name",
      "type": "text"
    },
    model: {
      value: (_vm.draftName),
      callback: function($$v) {
        _vm.draftName = $$v
      },
      expression: "draftName"
    }
  })], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [_c('div', {
    staticClass: "panel21 panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-form-label labelAccordionForm"
  }, [_vm._v("\n                            Invoice\n                          ")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group col-6"
  }, [_c('f7-button', {
    staticClass: "button-inner-color button-round invoiceButton buttonAccordionForm",
    on: {
      "click": function($event) {
        return _vm.openImportAttachmentInvoice()
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('attachments.import_invoice')) + "\n                              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6"
  }, [_c('f7-button', {
    staticClass: "button-round button-inner-color invoiceButton buttonAccordionForm scanbutton",
    on: {
      "click": function($event) {
        return _vm.scanInvoice($event)
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('creation_forms.scan_invoice_form')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attachementNameLabel),
      expression: "attachementNameLabel"
    }],
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "type": "text",
      "placeholder": "Select a file...",
      "readonly": "",
      "id": "application-file-input"
    },
    domProps: {
      "value": (_vm.attachementNameLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.attachementNameLabel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "item-input hiddenElementAllSize local-file-input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hiddenElementAllSize",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hiddenElementAllSize",
    attrs: {
      "type": "text",
      "id": "recommendation-list-input"
    }
  })]), _vm._v(" "), (_vm.attachementName !== '') ? _c('div', {
    staticClass: "col-sm-4",
    class: _vm.colorBottomButton
  }, [_c('f7-button', {
    staticClass: "button-round button-inner-color invoiceButton buttonAccordionForm",
    on: {
      "click": function($event) {
        return _vm.clearInvoice()
      }
    }
  }, [_vm._v("Clear")])], 1) : _vm._e()])])]), _vm._v(" "), (_vm.attachementName !== '') ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-4 col-sm-2 col-form-label labelAccordionForm"
  }, [_vm._v("\n                          Reference\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attachementReference),
      expression: "attachementReference"
    }],
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "placeholder": "Reference",
      "type": "text"
    },
    domProps: {
      "value": (_vm.attachementReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.attachementReference = $event.target.value
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "col-sm-6",
    class: _vm.colorBottomButton
  }, [_c('a', {
    attrs: {
      "href": "/payments/contactDebtorList/"
    }
  }, [_c('span', {
    staticClass: "button button-round button-inner-color",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('sent.select_cntct_btn', {
    contacttype: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))
  })) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "test-title subtitleDebtorList col-sm-4 col-form-label labelAccordionForm",
    class: {
      redFont: _vm.debtorListColor
    }
  }, [_vm._v("\n                  " + _vm._s(this.selected.length) + " debtor(s) selected\n                ")]), _vm._v(" "), (_vm.isOcrActive === true) ? _c('div', {
    staticClass: "col-sm-4",
    class: _vm.colorBottomButton
  }, [_c('input', {
    staticClass: "item-input hiddenElementAllSize rib-file-input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.executeOCROnRIB
    }
  }), _vm._v(" "), _c('f7-button', {
    staticClass: "button-round button-inner-color attachmentButton buttonAccordionForm",
    on: {
      "click": function($event) {
        return _vm.importRIB($event)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('sent.import_RIB_btn', {
    contacttype: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))
  })) + "\n                  ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-12 col-form-label labelAccordionForm"
  }, [_c('div', {
    staticClass: "grayEmpty"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "subtitleDebtorList",
    class: {
      redFont: _vm.debtorListColor
    }
  }, [_vm._v("Add Other Debtor")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": true,
      "idLabel": _vm.$t('common.nme'),
      "placeholderValue": _vm.$t('common.debtor_name')
    },
    model: {
      value: (_vm.debtorName),
      callback: function($$v) {
        _vm.debtorName = $$v
      },
      expression: "debtorName"
    }
  }), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "isMandatory": true,
      "idLabel": _vm.$t('common.idtfr'),
      "placeholderValue": _vm.$t('common.debtor_email')
    },
    model: {
      value: (_vm.debtorEmail),
      callback: function($$v) {
        _vm.debtorEmail = $$v
      },
      expression: "debtorEmail"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": true,
      "idLabel": _vm.$t('bank_accounts.bank_account_singular'),
      "placeholderValue": _vm.$t('common.debtor_iban')
    },
    model: {
      value: (_vm.debtorBank),
      callback: function($$v) {
        _vm.debtorBank = $$v
      },
      expression: "debtorBank"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 form-group centraliseDebtorButtons"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-6",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "paymentsRequestAddOtherDebtor"
  }, [_c('a', {
    staticClass: "button button-round button-inner-color",
    attrs: {
      "href": "/payments/debtorList/"
    }
  }, [_vm._v("\n                            " + _vm._s(this.enteredDebtors.length) + " debtor(s) added\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "paymentsRequestAddOtherDebtor",
    on: {
      "click": _vm.addDebtor
    }
  }, [_c('a', {
    staticClass: "button button-round button-inner-color",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Add to request\n                          ")])])])])])], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 form-group"
  }, [_c('label', {
    staticClass: "createInvoiceBand"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("bank_accounts.my_account")) + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v(" "), _c('div', {
    staticClass: "showSmallScreenOnly form-group",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "button button-round button-inner-color buttonAccordionForm",
    on: {
      "click": function($event) {
        return _vm.accountPicker($event)
      }
    }
  }, [_vm._v("\n                Select\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "showSmallScreenOnly"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.creditorBankName),
      expression: "creditorBankName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "account-inputDP",
      "type": "text",
      "placeholder": "Select an account ...",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.creditorBankName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.creditorBankName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "showLargeScreenOnly"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.creditorBank),
      expression: "creditorBank"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "sel2",
      "readonly": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.creditorBank = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select an account ...")]), _vm._v(" "), _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('option', {
      key: bankAccount.id,
      domProps: {
        "value": bankAccount.iban
      }
    }, [_vm._v(" " + _vm._s(bankAccount.name))])
  })], 2)])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [(_vm.directPayments === '1') ? _c('div', [_vm._v("\n                  DIRECT PAYMENT DETAILS\n                  "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])]) : _c('div', [_vm._v("\n                  REQUEST TO PAY DETAILS\n                  "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content hasDatePicker"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": true,
      "idLabel": _vm.$t('common.rsn'),
      "placeholderValue": _vm.$t('common.rsn')
    },
    model: {
      value: (_vm.remittanceInformation),
      callback: function($$v) {
        _vm.remittanceInformation = $$v
      },
      expression: "remittanceInformation"
    }
  }), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "isMandatory": true,
      "idLabel": _vm.$t('common.date_label'),
      "placeholderValue": _vm.$t('common.slct_date'),
      "inputType": 'date'
    },
    model: {
      value: (_vm.executionDate),
      callback: function($$v) {
        _vm.executionDate = $$v
      },
      expression: "executionDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": true,
      "idLabel": _vm.$t('common.amnt'),
      "placeholderValue": _vm.$t('common.amnt'),
      "inputType": 'number'
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  }), _vm._v(" "), (_vm.directPayments === '0') ? _c('div', {
    staticClass: "col-sm-6 centraliseCheckBox"
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false,
      "id": "modificationAcceptedCheckbox"
    },
    model: {
      value: (_vm.modificationAccepted),
      callback: function($$v) {
        _vm.modificationAccepted = $$v
      },
      expression: "modificationAccepted"
    }
  }, [_c('label', {
    staticClass: "labelAccordionForm",
    attrs: {
      "for": "modificationAcceptedCheckbox"
    }
  }, [_vm._v("\n                Creditor may negotiate\n              ")])])], 1) : _vm._e()], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-start",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "col-md-3 offset-md-1"
  }, [_c('button', {
    staticClass: "button-action firstButtonMarginTop",
    class: _vm.savePosition,
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.getNameDraft
    }
  }, [_c('i', {
    staticClass: "icon fa fa-save"
  }), _vm._v("\n          Save Request\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 offset-md-4"
  }, [(_vm.clearance === '1' | _vm.clearance === '2') ? _c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.sendPayments
    }
  }, [_c('i', {
    staticClass: "icon fa fa-paper-plane"
  }), _vm._v("\n          Send Request\n        ")]) : _vm._e()])])]), _vm._v(" "), (_vm.directPayments === '1') ? _c('f7-button', {
    staticClass: "button-round orangeConfirmationButton",
    on: {
      "click": _vm.sendDirectPayments
    }
  }, [_vm._v("\n          Send Direct Payments\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h6', {
    staticClass: "content-block labelAccordionForm creationFormTitle"
  }, [_c('img', {
    staticClass: "formIcon",
    attrs: {
      "src": require("../../../assets/static/images/icons/inbox_out.png")
    }
  }), _vm._v("\n                        New Request to Pay\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                            INVOICE\n                            "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                      RECIPIENT LIST\n                      "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                MY ACCOUNT INFORMATION\n                "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e082b86c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e082b86c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/creationPages/PRCreateTemplate.vue
// module id = 1725
// module chunks = 2